import {
  MenuLevel
} from './MenuLevel';
import {
  LevelLink
} from './LevelLink';

export class MenuTree {
  private levels: MenuLevel[];

  constructor() {
    let testItems = [
      new MenuLevel(
        [
          new LevelLink('Головна', '/', -1, 0),
          new LevelLink('Зали', null, 1, 0),
          new LevelLink('Наші фотографи', 'photographers', -1, 0),
          new LevelLink('Контакти', 'contacts', -1, 0),
          new LevelLink('Правила оренди', 'rules', -1, 0),
          new LevelLink('Послуги', null, 2, 0),
          new LevelLink('Обладнання', 'equipment', -1, 0),
          new LevelLink('Портфоліо', 'portfolio', -1, 0),
          new LevelLink('Календар', 'calendar', -1, 0),
        ],
        -1, 0),

      new MenuLevel(
        [
          new LevelLink('Open Space', 'open-space', -1, 0),
          new LevelLink('Fashion Space', 'fashion-space', -1, 0),
          new LevelLink('Loft Space', 'loft-space', -1, 0),
          new LevelLink('White Space', 'white-space', -1, 0),
          new LevelLink('Black Space', 'black', -1, 0),
          new LevelLink('Morning', 'hygge-space', -1, 0),
          new LevelLink('Make Up & Dress room', 'make-up-dress-room', -1, 0),
        ],
        0, 1),
    ];
      this.setLevels(testItems);
  }

   getLevels = (): MenuLevel[] => {
    return this.levels;
  }

  setLevels = (levels: MenuLevel[]): void => {
    this.levels = levels;
  }

  addLevel = (level: MenuLevel): void => {
    this.levels.push(level);
  }
}
